import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwitchAccountComponent } from './switch-account.component';

@NgModule({
  imports: [CommonModule],
  declarations: [SwitchAccountComponent]
})
export class SwitchAccountModule {}
